import axios from 'axios'

var local       = "http://localhost:3000/dev/api/"   //local
var admin       = "https://7envxt4fmk.execute-api.ap-south-1.amazonaws.com/dev/api/";           //admin_api
var master      = "https://wfrybvrnbc.execute-api.ap-south-1.amazonaws.com/dev/api/"            //master_api

var header = {
    headers: {
        "Content-Type": "application/json"
    }
};
export default {
    login(data) {
        return axios.post(master + "data/login", JSON.stringify(data), header)
    },
    dashboardcount(data) {
        return axios.post(admin + "master/GetDashboardDetails", JSON.stringify(data), header)
    },
    
    //send notification
    pushnotificationlistmaster(data) {
        return axios.post(master + "data/pushnotificationlistmaster", JSON.stringify(data), header)
    },
    sendpushnotification(data) {
        return axios.post(master + "Data/sendpushnotification", JSON.stringify(data), header)
    },
    
    
    
    
    //approval api
    ApplicationList(data) {
        return axios.post(master + "data/AdminApplicationList", JSON.stringify(data), header)
    },
    ReadRejectReason(data) {
        return axios.post(master + "data/ReadRejectReason", JSON.stringify(data), header)
    },
    RoleStatusMappingByAppStatus(data) {
        return axios.post(master + "data/RoleStatusMappingByAppStatus", JSON.stringify(data), header)
    },
    ApplicationApproval(data) {
        return axios.post(master + "data/ApplicationApproval", JSON.stringify(data), header)
    },
    ApplicationLogHistory(data) {
        return axios.post(master + "data/ApplicationLogHistory", JSON.stringify(data), header)
    },
    schemelist(data) {
        return axios.post(master + "data/AdminSchemeList", JSON.stringify(data), header)
    },
    Addschememaster(data) {
        return axios.post(master + "data/AddScheme", JSON.stringify(data), header)
    },
    Editchememaster(data) {
        return axios.post(master + "data/EditScheme", JSON.stringify(data), header)
    },
    Deletescheme(data) {
        return axios.post(master + "data/schemedelete", JSON.stringify(data), header)
    },
    batchlist(data) {
        return axios.post(master + "data/AdminBatchList", JSON.stringify(data), header)
    },
    Addbatchmaster(data) {
        return axios.post(master + "data/AddBatch", JSON.stringify(data), header)
    },
    Editbatchmaster(data) {
        return axios.post(master + "data/EditBatch", JSON.stringify(data), header)
    },
    Deletebatch(data) {
        return axios.post(master + "data/Batchdelete", JSON.stringify(data), header)
    },
    schemeDropdown(data) {
        return axios.post(master + "data/schemedropdown", JSON.stringify(data), header)
    },
    GetApplicationTemp(data) {
        return axios.post(admin + "scheme/ApplicationTemp", JSON.stringify(data), header)
    },
    // notification API
    notificationList(data) {
        return axios.post(master + "notification/AdminNotificationList ", JSON.stringify(data), header)
    },
    addNotification(data) {
        return axios.post(master + "notification/AdminAddNotification ", JSON.stringify(data), header)
    },
    editNotification(data) {
        return axios.post(master + "notification/AdminEditNotification ", JSON.stringify(data), header)
    },
    deleteNotification(data) {
        return axios.post(master + "notification/AdminDeleteNotification ", JSON.stringify(data), header)
    },
    HoardingDropdownList(data) {
        return axios.post(master + "notification/HoardingDropdownList ", JSON.stringify(data), header)
    },
    UserDropdownList(data) {
        return axios.post(master + "notification/UserDropdownList ", JSON.stringify(data), header)
    },
    StateList(data) {
        return axios.post(master + "notification/StateList ", JSON.stringify(data), header)
    },
    DistrictList(data) {
        return axios.post(master + "notification/DistrictList ", JSON.stringify(data), header)
    },
    MuncipalCorporationList(data) {
        return axios.post(master + "notification/MuncipalCorporationList ", JSON.stringify(data), header)
    },
    AdminHoardingMasterList(data) {
        return axios.post(master + "notification/AdminHoardingMasterList2 ", JSON.stringify(data), header)
    },
    DashboardSearch(data) {
        return axios.post(master + "notification/DashboardSearch ", JSON.stringify(data), header)
    },
    HoardingTypeList(data) {
        return axios.post(master + "notification/HoardingTypeList ", JSON.stringify(data), header)
    },
    NewApplicationList(data) {
        return axios.post(master + "notification/AdminNewApplicationList ", JSON.stringify(data), header)
    },
    ApprovalAccess(data) {
        return axios.post(master + "notification/ApprovalAccess ", JSON.stringify(data), header)
    },
    //Admin user master
    adminuserlist(data) {
        return axios.post(master + "user/AdminUserList", JSON.stringify(data), header)
    },
    admineditusermaster(data) {
        return axios.post(master + "user/AdminEditUser", JSON.stringify(data), header)
    },
    adminaddusermaster(data) {
        return axios.post(master + "user/AdminAddUser", JSON.stringify(data), header)
    },
    admindeleteusermaster(data) {
        return axios.post(master + "user/AdminDeleteUser", JSON.stringify(data), header)
    },
    roleIDlist(data) {
        return axios.post(master + "user/UserRoleDropdown", JSON.stringify(data), header)
    },
    upload_to_AWS(data) {
        return axios.post(admin + 'getSignedUrlsgb/getSignedURL', JSON.stringify(data), {
            headers: {
                "Content-Type": "application/json"
            }
        });
    },
    // Complaints API -----------------------------
    ticketlist(data) {
        return axios.post(admin + "complaint/ticketlist", JSON.stringify(data), header)
    },
    deleteTicket(data) {
        return axios.post(admin + "complaint/deleteTicket", JSON.stringify(data), header)
    },
    getclientist(data) {
        return axios.post(admin + "complaint/getclientist", JSON.stringify(data), header)
    },
    TicketStatusMaster(data) {
        return axios.post(admin + "complaint/getTicketStatusMaster", JSON.stringify(data), header)
    },
    agentListDropdown(data) {
        return axios.post(admin + "complaint/agentListDropdown", JSON.stringify(data), header)
    },
    getTicketSource(data) {
        return axios.post(admin + "complaint/getTicketSource", JSON.stringify(data), header)
    },
    TicketCategoryMaster(data) {
        return axios.post(admin + "complaint/getTicketCategoryMaster", JSON.stringify(data), header)
    },
    updateTicketStatus(data) {
        return axios.post(admin + "complaint/updateticketstatus", JSON.stringify(data), header)
    },
    assignAgent(data) {
        return axios.post(admin + "complaint/assignAgent", JSON.stringify(data), header)
    },
    categoryListmaster(data) {
        return axios.post(admin + "complaint/categoryListmaster", JSON.stringify(data), header)
    },
    categoryAddEdit(data) {
        return axios.post(admin + "complaint/categoryAddEdit", JSON.stringify(data), header)
    },
    deleteCategory(data) {
        return axios.post(admin + "complaint/deleteCategory", JSON.stringify(data), header)
    },
    getticketDetails(data) {
        return axios.post(admin + "complaint/ticketDetails", JSON.stringify(data), header)
    },
    getApplicationDetailsbyID(data) {
        return axios.post(admin + "scheme/getApplicationDetailsbyID", JSON.stringify(data), header)
    },
    bannerlist(data) {
        return axios.post(master + "banner/BannerApplicationList  ", JSON.stringify(data), header)
    },
    AddBanner(data) {
        return axios.post(master + "banner/AddBanner", JSON.stringify(data), header)
    },
    EditBanner(data) {
        return axios.post(master + "banner/EditBanner", JSON.stringify(data), header)
    },
    BannerDelete(data) {
        return axios.post(master + "banner/BannerDelete", JSON.stringify(data), header)
    },
    // upload_to_AWS(data)
    // {
    //      return axios.post(admin+"getSignedUrlsgb/getSignedURL", JSON.stringify(data),  header);
    // },
}